import {
    Box,
    Button,
    Grid,
} from "@mui/material";
import './PrivateLayout.scss';
import {NavLink} from "react-router-dom";
import {ReactNode, useState} from "react";
import AppHeader from "./Header/AppHeader";
import InboxConfirming from "./Inbox/InboxConfirming";

export default function PrivateLayout(props: {element: ReactNode}) {
    const [showed, setShowed] = useState(false)

    function menuWrapperClassName() {
        if(showed){
            return "menuWrapper showed";
        }
        return "menuWrapper";
    }

    return (
        <div>
            <InboxConfirming />
            <AppHeader onMenuToggle={() => setShowed(!showed)}/>
            <Button className="MenuMobileButton" fullWidth onClick={() => setShowed(!showed)}>Menu</Button>
            <Grid container className="privateWrapper">
                <Grid item xs={12} md={4} lg={3} className={menuWrapperClassName()}>
                    <Box className="menu">
                        <NavLink to="/" onClick={() => setShowed(false)}><span>Aktualne dane podmiotu</span></NavLink>
                        <NavLink reloadDocument to="/nadaj-pismo" onClick={() => setShowed(false)}><span>Nadaj pismo</span></NavLink>
                        <NavLink reloadDocument to="/skrzynka-odbiorcza" onClick={() => setShowed(false)}><span>Skrzynka odbiorcza</span></NavLink>
                        <NavLink to="/lista-pism" onClick={() => setShowed(false)}><span>Wygenerowane pisma</span></NavLink>
                        <NavLink reloadDocument to="/sprawdz-pismo" onClick={() => setShowed(false)}><span>Sprawdź sygnaturę pisma</span></NavLink>
                        <NavLink to="/raporty" onClick={() => setShowed(false)}><span>Raporty</span></NavLink>
                        <NavLink to="/subskrypcje" onClick={() => setShowed(false)}><span>Abonament</span></NavLink>
                    </Box>
                </Grid>

                <Grid item  xs={12} md={8} lg={9}>
                    <Box className="privateContentWrapper">
                        {props.element}
                    </Box>
                </Grid>
            </Grid>
        </div>
    )
}
